import script from "./CallWaiterModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CallWaiterModal.vue?vue&type=script&setup=true&lang=js"

import "./CallWaiterModal.vue?vue&type=style&index=0&id=b9e05ba4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.19_vue@3.4.19_webpack@5.90.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9e05ba4"]])

export default __exports__